export const INVENTORY_VARIANT = 'variant2';
export default { INVENTORY_VARIANT };
